import React from "react";

import {
  AccountBalanceRounded,
  DirectionsBusRounded,
  ExpandMoreRounded,
  SchoolRounded,
  SwapHorizRounded,
  SyncRounded,
} from "@mui/icons-material";
import { AccordionDetails, AccordionSummary, Box } from "@mui/material";

import useFirebase from "../../../../../config/context/firebaseContext";
import useBus from "../../context";

import MainText from "../../../../../components/MainText";
import DepartOptions from "../DepartOptions";
import DepartTable from "../DepartTable";

import { StyledAccordion } from "./styles";

export default function Departs() {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const { analyticLog } = useFirebase();

  const { busSchedules, activeRule, weekDay, nextBuses } = useBus();

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);

    if (isExpanded) analyticLog("click_depart", { bus: panel });
  };

  return (
    <Box>
      <Box mb={1}>
        {!!activeRule?.days?.[weekDay]?.length && (
          <MainText size="body">Horários de Saída</MainText>
        )}
        <MainText size="tiny" color="regular">
          * Horários de saída de seus respectivos terminais, sendo: Expressos partem do Via. Direto
          e Inverso partem do RU
        </MainText>
      </Box>

      {!!activeRule?.days?.[weekDay] &&
        activeRule?.days?.[weekDay].map((busId) => {
          return (
            <StyledAccordion
              key={busId}
              accordioncolor={busSchedules?.[busId]?.color}
              expanded={expanded === busId}
              onChange={handleChange(busId)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreRounded />}
                aria-controls="sabado-bh-content"
                id="sabado-bh-header"
              >
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Box display={"flex"}>
                    {busId.includes("direto") ? (
                      <SwapHorizRounded style={{ marginRight: 10 }} />
                    ) : busId.includes("inverso") ? (
                      <SyncRounded style={{ marginRight: 10 }} />
                    ) : busId.includes("reitoria") ? (
                      <AccountBalanceRounded style={{ marginRight: 10 }} />
                    ) : busId.includes("cet") ? (
                      <SchoolRounded style={{ marginRight: 10 }} />
                    ) : (
                      <DirectionsBusRounded style={{ marginRight: 10 }} />
                    )}

                    <MainText color="white">{busSchedules?.[busId]?.name}</MainText>
                  </Box>

                  <Box
                    display={"flex"}
                    justifyContent="center"
                    flexDirection={"column"}
                    alignItems="center"
                    pr={1}
                  >
                    {nextBuses[busId]?.previous ? (
                      <MainText size="tiny" color="ghost-regular">
                        {nextBuses[busId]?.previous}
                      </MainText>
                    ) : null}
                    {nextBuses[busId]?.next ? (
                      <MainText size="small" color="white">
                        {nextBuses[busId]?.next}
                      </MainText>
                    ) : null}
                    {nextBuses[busId]?.upNext ? (
                      <MainText size="tiny" color="ghost-regular">
                        {nextBuses[busId]?.upNext}
                      </MainText>
                    ) : null}
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ "& *": { boxSizing: "border-box" } }}>
                <DepartTable
                  busId={busId}
                  scheduleBus={busSchedules?.[busId]?.schedule}
                  showFullHour
                />
              </AccordionDetails>
            </StyledAccordion>
          );
        })}

      <DepartOptions />
    </Box>
  );
}
